import Api from "../Api/Api";

export const getSchema = () => Api.get("admin/dataIntelligence/schema");

export const runQuery = (sql) =>
    Api.post("admin/dataIntelligence/runQuery", { sql });
